import { Component, OnInit } from '@angular/core';
import { AndFilter, Filter, FilterOperation, HasFilter, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { WorkersService } from '../_services/workers.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { ChatService } from '../../chat/_services/chat.service';
import { Worker } from '../_types/worker';
import { CapabilitiesService } from '../../common/_services/capabilities.service';
import { ZonesService } from '../../zones/_services/zones.service';
import { CountriesRegionsService } from '../../common/_services/countries-regions.service';
import { SessionStorageService } from 'angular-web-storage';
import { LoginService } from '../../login/login.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';

type FilterOption = { label: string; value: any };

@Component({
    selector: 'app-workers-list',
    templateUrl: './workers-list.component.html',
    styleUrls: ['./workers-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class WorkersListComponent implements OnInit {
  public workers: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    description: new Filter(FilterOperation.contains, 'description'),
    //capabilityId: new HasFilter('workerCapabilities',new Filter(FilterOperation.equals, 'capabilityId')),
    capabilityId: new HasFilter('workerCapabilities',
      new AndFilter([
        new Filter(FilterOperation.equals, 'capabilityId'),
         new Filter(FilterOperation.equals, 'normalServiceAllowed', ''),
         new Filter(FilterOperation.equals, 'guardServiceAllowed', '')
      ])
    ),
   
    countryRegionId: new Filter(FilterOperation.equals, 'address.countryRegionId'),
    zoneId: new HasFilter('workerZones', new Filter(FilterOperation.equals, 'zoneId')),    
    active: new Filter(FilterOperation.equals, 'active', '', true),
    typeOfBusiness: new Filter(FilterOperation.equals, "typeOfBusiness"),
    vatNumber: new Filter(FilterOperation.contains, 'vatNumber'),
    zipCode: new HasFilter('workerZones', 
      new AndFilter([
        new OrFilter([
          new HasFilter('zone.zoneLines', new Filter(FilterOperation.equals, 'value')),
          new Filter(FilterOperation.equals, 'value'), 
        ]),
        new Filter(FilterOperation.equals, 'normalServiceAllowed', ''),
        new NotFilter(FilterOperation.contains, 'excludedZipCodes', '')
      ])
    ),
    zipCodeGuard: new HasFilter('workerZones', 
      new AndFilter([
        new OrFilter([
          new HasFilter('zone.zoneLines', new Filter(FilterOperation.equals, 'value')),
          new Filter(FilterOperation.equals, 'value'), 
        ]),
        new Filter(FilterOperation.equals, 'guardServiceAllowed', ''),
        new NotFilter(FilterOperation.contains, 'excludedZipCodes', '')
      ])
    ),
    phoneNumber:new OrFilter([
       new Filter(FilterOperation.contains, 'phone1'),
       new Filter(FilterOperation.contains, 'phone2')
    ]),
    email: new Filter(FilterOperation.contains, 'email')
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public capabilities: any[] = [];
  public countriesRegions: any[] = [];
  public zones: any[] = [];
  public activeOptions: any[] = [
    { id: null, name: 'Todos' },
    { id: true, name: 'Activo' },
    { id: false, name: 'Inactivo' }
  ];
public businessTypes:any[] = [
    { name: 'Autónomo', value: 'Person' },
    { name: 'Empresa', value: 'Company' },
    { name: 'Plantilla', value: 'Staff' }
  ];

  public capabilityOptions: FilterOption[] = [];
  public regionOptions: FilterOption[] = [];
  public zoneOptions: FilterOption[] = [];
  private lastRegionId: any = null;

  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.capabilityId.filter, type: 'select', label: 'Especialidad', options: this.capabilityOptions, filterable: true, base: true },
    { filter: this.filters.countryRegionId, type: 'select', label: 'Provincia', options: this.regionOptions, filterable: true, base: true },
    { filter: this.filters.zoneId.filter, type: 'select', label: 'Zona', options: this.zoneOptions, filterable: true, base: true },
    { filter: this.filters.active, type: 'select', label: 'Estado', options: [{ label: 'Activo', value: true }, { label: 'Inactivo', value: false }], base: true },
    { filter: this.filters.vatNumber, type: 'text', label: 'NIF/CIF' },
    { filter: this.filters.description, type: 'text', label: 'Nombre de contacto' },
    { filter: this.filters.zipCode.filter.filters[0].filters[0].filter, type: 'text', label: 'CP normal' },
    { filter: this.filters.zipCodeGuard.filter.filters[0].filters[0].filter, type: 'text', label: 'CP guardia' },
    { filter: this.filters.email, type: 'text', label: 'Email' },
    { filter: this.filters.phoneNumber, type: 'text', label: 'Teléfono' },
    { filter: this.filters.typeOfBusiness, type: 'select', label: 'Tipo', options: this.businessTypes.map(b => ({ label: b.name, value: b.value })) }
  ];
  constructor(
    private workersService: WorkersService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private topbarService: TopbarService,
    private chatService: ChatService,
    private capabilitiesService: CapabilitiesService,
    private countriesRegionsService: CountriesRegionsService,
    private zonesService: ZonesService,
    private sessionStorage: SessionStorageService,
    private loginService: LoginService
  ) {
   
  }
  ngOnInit(): void {
    this.topbarService.setTitle("Operarios");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");

    //recuperar filtros guardados
    let savedFilters = this.sessionStorage.get("workersFilters");
    if(savedFilters!=null) {
      console.log(savedFilters);
      if(savedFilters.phoneNumber.filters[0].value) {
        savedFilters.phoneNumber.value = savedFilters.phoneNumber.filters[0].value;
        this.filters.phoneNumber.value = savedFilters.phoneNumber.filters[0].value;
      }
      FilterBuilder.loadSavedFilters(this.filters, savedFilters);
    }

    console.log(this.filters, savedFilters);

    this.loadCapabilities();
    this.loadZones();
    this.loadCountriesRegions();
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: $event.first + 1, size: $event.rows },
      include: ['address', 'parentWorker'],
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //guardamos los filtros en la sesion
    this.sessionStorage.set("workersFilters", this.filters);

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.workersService.all(params));

    //miramos si tiene el filtro de especialidad

    this.workers = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);

  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;

    if (this.filters.countryRegionId.value !== this.lastRegionId) {
      this.lastRegionId = this.filters.countryRegionId.value;
      this.loadZones();
    }

    //Se hace esto porque si filtran por zipCOde de guardia y tiene filtro de Especialidades, no funcionaba bien. CREO que ahora si.
    if(this.filters.capabilityId.filter.value != null){
      this.filters.capabilityId.filter.filters[0].value = this.filters.capabilityId.filter.value;
      this.filters.capabilityId.filter.filters[1].value = null; //Los vacio siempre
      this.filters.capabilityId.filter.filters[2].value = null;
    }else{
      this.filters.capabilityId.filter.filters[0].value = null;
      this.filters.capabilityId.filter.filters[1].value = null; //Los vacio siempre
      this.filters.capabilityId.filter.filters[2].value = null;
    }
    
    //copiamos el filtro de zipCode
    //this.filters.zipCode.filter.filters[0].filter.value = this.filters.zipCode.filter.filters[0].filter.value;
    this.filters.zipCode.filter.filters[0].filters[1].value = this.filters.zipCode.filter.filters[0].filters[0].filter.value;
    this.filters.zipCodeGuard.filter.filters[0].filters[1].value = this.filters.zipCodeGuard.filter.filters[0].filters[0].filter.value;
    
    //si no hay filtro de cp guardia, desactivamos el flag
    if(this.filters.zipCode.filter.filters[0].filters[0].filter.value=='' || this.filters.zipCode.filter.filters[0].filters[0].filter.value==null){
      this.filters.zipCode.filter.filters[1].value = null;
      this.filters.zipCode.filter.filters[2].value = null;
    }else{
      //añadimos y que no este excluido de la zona
      this.filters.zipCode.filter.filters[2].value = this.filters.zipCode.filter.filters[0].filters[0].filter.value;

      this.filters.zipCode.filter.filters[1].value = true;
      if(this.filters.capabilityId.filter.value != null){
        this.filters.capabilityId.filter.filters[0].value = this.filters.capabilityId.filter.value;
        this.filters.capabilityId.filter.filters[1].value = true;
      }
    }

    //si no hay filtro de cp guardia, desactivamos el flag
    if(this.filters.zipCodeGuard.filter.filters[0].filters[0].filter.value=='' || this.filters.zipCodeGuard.filter.filters[0].filters[0].filter.value==null){
      this.filters.zipCodeGuard.filter.filters[1].value = null;
      this.filters.zipCodeGuard.filter.filters[2].value = null;
    }else{
      //añadimos y que no este excluido de la zona
      this.filters.zipCodeGuard.filter.filters[2].value = this.filters.zipCodeGuard.filter.filters[0].filters[0].filter.value;
      
      this.filters.zipCodeGuard.filter.filters[1].value = true;
       if(this.filters.capabilityId.filter.value != null){
        this.filters.capabilityId.filter.filters[0].value = this.filters.capabilityId.filter.value;
        this.filters.capabilityId.filter.filters[2].value = true; //marcamos y que este de guardia
      }
    }

    this.filters.phoneNumber.filters[0].value = this.filters.phoneNumber.value;
    this.filters.phoneNumber.filters[1].value = this.filters.phoneNumber.value;

    console.log(this.filters);

    this.loadData(this.lastGridEvent);
  }

  edit(worker: any) {
    this.router.navigate(['workers/' + (worker && Object.keys(worker).length > 0 ? worker.id : 0)]);
  }

  delete(worker: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el operario?",
        header: "Eliminar operario",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.workersService.delete(worker.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Operario eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  getSeverity(active: boolean) {
    if (active) {
      return 'success';
    } else {
      return 'danger';
    }
  }

  openChat(worker: Worker) {
    this.chatService.openChatWorker(worker);
  }

  async loadCapabilities() {
    let response = await firstValueFrom(this.capabilitiesService.all());
    this.capabilities = response.data;
    this.fillOptions(this.capabilityOptions, response.data);
  }
  async loadCountriesRegions() {
    let response = await firstValueFrom(this.countriesRegionsService.all());
    this.countriesRegions = response.data;
    this.fillOptions(this.regionOptions, response.data);
  }

  async loadZones() {

    let filters:any = {
      countryRegionId: new Filter(FilterOperation.equals, 'countryRegionId', '')
    };
    if(this.filters.countryRegionId.value != null) filters.countryRegionId.value = this.filters.countryRegionId.value;
    let params: IParamsCollection = {
      page: { size: 1000 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.zonesService.all(params));
    this.zones = response.data;
    this.fillOptions(this.zoneOptions, response.data);
  } 

  private fillOptions(target: FilterOption[], items: any[]) {
    target.length = 0;
    target.push(...items.map(item => ({ label: item.name, value: item.id })));
  }

  onCountryRegionChange($event:any){
      //this.selectedCountryRegionId = $event.value;
      this.loadZones();
    }
  
}
